export default "__VITE_ASSET__Credynyo__"